import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** clsx로 className을 합친 뒤 tailwind-merge로 충돌하는 Tailwind 유틸을 정리한다. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map